import { FirebaseConfig } from './remote-config'

export default function isSseBlacklisted(firebaseConfig: FirebaseConfig, athlinksEventId: number) {
  const raw = firebaseConfig.config.useSseEventBlacklist?.asString() ?? ''
  const blacklistedEvents = raw.split(',').map(x => +x).filter(y => !!y)

  return blacklistedEvents.includes(athlinksEventId)
}